import gql from 'graphql-tag';

/**
 * Query to fetch inspection templates for a building.
 * Returns full template data including sections and items.
 */
export const getInspectionTemplatesQuery = gql`
  query getInspectionTemplates($buildingId: SourceEntityIdentifierInput!) {
    inspectionTemplates(buildingId: $buildingId) {
      id
      schemaVersion
      version
      parentTemplateId
      locked
      parentTemplateLockedVersion
      metadata {
        name
        description
        templateType
        assetTypes
        tags
        buildingId {
          sourceEntityId
          sourceEntityType
          sourceType
        }
        createdAt
        createdBy
        updatedAt
        updatedBy
      }
      config {
        requirePhotoOnDeficiency
        maxPhotosPerItem
        requireNoteOnDeficiency
        defaultQuestionType
        allowObservationItems
        completionRules {
          allItemsRequired
          allowPartialSubmission
        }
      }
      sections {
        id
        name
        description
        order
        config {
          requirePhotoOnDeficiency
          skippable
          collapsedByDefault
        }
        items {
          id
          label
          helpText
          order
          questionType
          questionConfig
          required
          photosEnabled
          notesEnabled
          config {
            requirePhotoOnDeficiency
            requireNoteOnDeficiency
            minPhotos
            isComplianceItem
            tags
            category
          }
        }
      }
    }
  }
`;
